import ReactVisibilitySensor from "react-visibility-sensor";
import Counter from "../Counter/Counter";
import { useContext } from "react";
import { LangContext } from "../../App";

export type BoxPropsType = {
    title? : string;
    number? : number | string;
    subtitle? : string;
    unit? : string | JSX.Element;
    text? : string;
    percentage? : number | string;
    percentageString? : string;
    size? : string;
}

const BorderCenterLabel = ({ boxes, justifyContent = "flex-start" } : { boxes : BoxPropsType[], justifyContent? : string }) => {
    const { lang } = useContext(LangContext);

  return (
    <div className={`border-center-label ${lang === 0 ? "" : "rtl"}`}>
        <div className="wrapper-small">
            <div className="label-row" style={{ justifyContent : justifyContent }}>
            {boxes.map((item, index) => (
                <div key={index} className={`label-col ${(justifyContent === "space-around") ? "label-col-second" : ""} label-col-${item.size} an-move-left-fade-in an-active`}>
                    
                    {item.number ? 
                    <h3 className="label-number">
                        {typeof item.number === "number" ? 
                        <Counter counterValue={item.number} applyCounteClassName={"label-number"} /> :
                        item.number
                        }
                    </h3> : 
                    ""}
                    {item.title ? <h3 className="label-title">{item.title}</h3> : ""}
                    {item.percentage ? <h3 className="label-percentage">{item.percentage}{lang ? "" : "%"}</h3> : ""}
                    {item.subtitle ? <h4 className="label-subtitle">{item.subtitle}</h4> : ""}
                    {item.unit ? <p className="label-unit">{item.unit}</p> : ""}
                </div>
            ))}
            </div>
        </div>
    </div>
  )
}

export default BorderCenterLabel